import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import CardSeplag from "../../../../components/CardSeplag";
import QuestionarioSeplag from "../../../../components/QuestionarioSeplag";
import { buscarPerfil, printToast, summaryExclusaoSucessoPadrao } from "../../../../config/global";
import { salvarAvaliacaoPrograma } from "../../../../service/Rag/AvaliacaoPrograma";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import {
  buscaTipoSugestaoMelhoria,
  buscaSugestaoMelhoriaGeral,
  adicionarSugestaoMelhoria,
  editarSugestaoMel,
  excluirSugestaoMel,
} from "../../../../service/Rag/AvaliacaoAcao";
import CardSeplagScrol from "../../../../components/CardSeplag/CardSeplagScrol";
import RotuloSeplag from "../../../../components/RotuloSeplag";
import { InputTextarea } from "primereact/inputtextarea";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const AvaliacaoProgramaRagSugestao = (props) => {
  const [campos, setCampos] = useState(JSON.parse(props.questionario));
  const [tipoMelhoria, setTipoMelhoria] = useState(null);
  const [selectedTipoMelhoria, setSelectedTipoMelhoria] = useState(null);
  const [countCaracteres, setCountCaracteres] = useState(0);
  const [campoHabilitado, setCampoHabilitado] = useState(true);
  const [value, setValue] = useState("");
  const [sugestaoMelhoria, setSugestaoMelhoria] = useState(0);
  const [atualizaGrid, setAtualizaGrid] = useState(true);
  const [editarItem, setEditarItem] = useState(false);
  const [idenSugestaoMelhoria, setIdenSugestaoMelhoria] = useState(0);
  const [clickVisualizar, setClickVisualizar] = useState(false);
  const location = useLocation();
  let history = useHistory();

  const [perfis] = useState({
    MONRL_ADMIN_CENTRAL: buscarPerfil("MONRL_ADMIN_CENTRAL"),
    MONRL_ANALISTA: buscarPerfil("MONRL_ANALISTA"),
    MONRL_ACESSO_ORGAO_CONTROLE: buscarPerfil("MONRL_ACESSO_ORGAO_CONTROLE"),
  });

  const nivelTipo = "P";
  const idProgramaAux = props.dadosItemPrograma.dadosItemRag.idenPrograma;

  const qtdMaxCaracteres = 4000;

  useEffect(() => {
    //Busca os dados do Banco, passando por parametro A-Acao ou P-Programa e seta a lista em memoria
    buscaTipoSugestaoMelhoria(nivelTipo).then((res) => {
      setTipoMelhoria(res.data);

      //console.log("TESTE_PODE_EDITAR_MELHORIA_PROGRAMA: ",location.state.podeAvaliarAcao)
    });
  }, []);

  useEffect(() => {
    //console.log("PtaMonitora:", props.dadosItemAcao.idenPtaMonitora)
    if (atualizaGrid) {
      buscaSugestaoMelhoriaGeral(nivelTipo, idProgramaAux).then((res) => {
        setSugestaoMelhoria(res.data);
        setAtualizaGrid(false); //volta o valor
      });
    }
  }, [idProgramaAux, atualizaGrid]);

  useEffect(() => {
    contarCaracteres();
  }, [value]);

  function contarCaracteres() {
    setCountCaracteres(value != null ? qtdMaxCaracteres - value.length : 4000);
  }

  const formatarMilhar = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  function podeAcessarCampo() {
    return location.state.PODE_ENVIAR_SUGESTAO_MELHORIA_PROGRAMA === true && campoHabilitado === true;
  }

  const verifyReadOnly = () => {
    if (location.state.PODE_ENVIAR_SUGESTAO_MELHORIA_PROGRAMA === false) {
      return true;
    }

    if (location.state.PODE_ENVIAR_SUGESTAO_MELHORIA_PROGRAMA === true && campoHabilitado === true) {
      if (clickVisualizar === true) {
        return true;
      }

      return false;
    }

    return false;
  };

  const voltar = () => {
    history.push({ pathname: "/raglancamentos", state: {} });
  };

  const salvar = () => {
    let v_campos = campos.map((questao) => {
      questao.valrRespostaItemQuest = questao.data;
      return { ...questao };
    });

    let codigoItem = campos[0].codigoItemRag;

    salvarAvaliacaoPrograma(codigoItem, v_campos).then((res) => {
      props.setCamposQuestionarioSugestao(JSON.stringify(campos));
      printToast({ summary: "Ação Efetuada", detail: "Sugestão salva com sucesso" });
    });
  };

  const adicionarItem = () => {
    //console.log("Clicou: " + selectedTipoMelhoria + " " + value + " " + idMonitoraAux)

    if (!selectedTipoMelhoria) {
      printToast({ summary: "Erro", detail: "Selecione um tipo de sugestão melhoria.", severity: "error" });
      return;
    }
    if (!value) {
      printToast({ summary: "Erro", detail: "Selecione uma mensagem de sugestão melhoria.", severity: "error" });
      return;
    }

    let camposSM = {
      idenPrograma: idProgramaAux,
      idenTipoSugestaoMelhoria: selectedTipoMelhoria,
      descSugestaoMelhoria: value,
      statSugestaoMelhoria: 1,
    };
    //console.log(camposSM)
    adicionarSugestaoMelhoria(camposSM, nivelTipo)
      .then((data) => {
        printToast({ summary: "Sugestão Adicionada", detail: "Sugestão de melhoria adicionada com sucesso" });
        setAtualizaGrid(true);
        setSelectedTipoMelhoria(null);
        setValue("");
      })
      .catch((err) => {
        printToast({ summary: "Erro", detail: "Falha ao adicionar sugestão de melhoria" });
      });
  };

  const remover = () => {};

  function editarItemGrid(rowData) {
    if (!selectedTipoMelhoria) {
      printToast({ summary: "Erro", detail: "Selecione um tipo de sugestão melhoria.", severity: "error" });
      return;
    }
    if (!value) {
      printToast({ summary: "Erro", detail: "Selecione uma mensagem de sugestão melhoria.", severity: "error" });
      return;
    }

    let camposSM = {
      idenPrograma: idProgramaAux,
      idenTipoSugestaoMelhoria: selectedTipoMelhoria,
      descSugestaoMelhoria: value,
      statSugestaoMelhoria: 1,
    };
    editarSugestaoMel(idenSugestaoMelhoria, camposSM).then((res) => {
      printToast({ summary: "Ação Efetuada", detail: "Sugestão de melhoria editada com sucesso" });
      setAtualizaGrid(true);
      setSelectedTipoMelhoria(null);
      setValue("");
      setEditarItem(false);
    });
  }

  function excluirSugestaoMelhoria(rowData) {
    //console.log("ClicouExclusaoSugestaoMelhoria",rowData)
    excluirSugestaoMel(rowData.idenSugestaoMelhoria).then((res) => {
      //    let andamentosExc = andamentos.filter((item) => item.idenAndamento != rowData.idenAndamento);
      //    //setAndamentos(andamentosExc);
      //    //setFormPta({ ...ptaMonitora, andamentos: andamentosExc });
      printToast({ summaryExclusaoSucessoPadrao, detail: "O registro foi excluído com sucesso" });
      setValue("");
      setAtualizaGrid(true);
    });
  }

  const rejectFunc = () => {};

  const confirmaExclusao = (rowData) => {
    confirmDialog({
      message: "Deseja excluir esta sugestão de melhoria?",
      header: "Confirmação",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => excluirSugestaoMelhoria(rowData),
      reject: () => rejectFunc(),
    });
  };

  const salvarDadosAtualizados = (e) => {
    props.setCamposQuestionarioSugestao(JSON.stringify(e));
    setCampos(e);
  };

  function visualizarSugestaoMelhoria(rowData) {
    setSelectedTipoMelhoria(rowData.idenTipoSugestaoMelhoria);
    setValue(rowData.descSugestaoMelhoria);
    setClickVisualizar(true);
  }

  function editarSugestaoMelhoria(rowData) {
    // console.log("ClicouEditarSugestaoMelhoria",rowData)
    setEditarItem(true);
    setIdenSugestaoMelhoria(rowData.idenSugestaoMelhoria);
    //console.log("rowData.idenSugestaoMelhoria_Programa",rowData)
    //console.log(editarItem)

    setSelectedTipoMelhoria(rowData.idenTipoSugestaoMelhoria);
    setValue(rowData.descSugestaoMelhoria);
    setClickVisualizar(false);

    setCampoHabilitado(true);
  }

  //debugger
  //Controle para identificar se o ano eh igual ou superior a 2024
  const exercicio2024 = props.dadosItemPrograma.dadosItemRag.exercicio.ano >= 2024 ? true : false;

  // const podeAcessar = podeAcessarCampo();
  // console.log("ResultadoPodeAcessarCampo:",podeAcessar)

  const acoesTemplate = (node, column) => {
    return (
      <>
        {/* {isPodeVisualizar && ( */}
        <Button
          style={{ justifyContent: "center" }}
          type="button"
          icon="pi pi-eye"
          className="p-button-primary Raised"
          onClick={() => visualizarSugestaoMelhoria(node)}
        ></Button>
        {/* )} */}
        <Button
          type="button"
          icon="pi pi-pencil"
          style={{ marginLeft: "5px", justifyContent: "center" }}
          className="p-button-warning Raised"
          onClick={() => editarSugestaoMelhoria(node)}
          disabled={!podeAcessarCampo()}
        ></Button>
        <Button
          type="button"
          icon="pi pi-trash"
          style={{ marginLeft: "5px", justifyContent: "center" }}
          className="p-button-danger Raised"
          onClick={() => confirmaExclusao(node)}
          //disabled={!isPodeEditar || !ptaMonitora.permiteAndamento}
          disabled={!podeAcessarCampo()}
        ></Button>
      </>
    );
  };

  const renderSugestao = (rowData) => {
    const maxLength = 80;
    const { descSugestaoMelhoria } = rowData; // Desestrutura o texto da sugestão

    if (descSugestaoMelhoria.length > maxLength) {
      return <span>{descSugestaoMelhoria.substring(0, maxLength)}...</span>;
    }

    return <span>{descSugestaoMelhoria}</span>;
  };


  return (
    <>
      <CardSeplagScrol title="Melhoria">
        {exercicio2024 && (
          <>
            <div style={{ marginRight: "10px" }}>
              <label>
                <p>
                  <b>
                    O Plano Plurianual (PPA) é um instrumento de planejamento estratégico fundamental para a
                    Administração Pública. Ele define as diretrizes, objetivos e metas do governo para um período de
                    quatro anos (médio prazo), priorizando recursos públicos para que, por meio dos PROGRAMAS DE
                    GOVERNO, sejam estabelecidos de forma clara e objetiva os problemas comuns da sociedade e como
                    (ações) e quanto desses problemas serão resolvidos (meta).
                  </b>
                  <br />
                  <br />
                  <b>
                    O planejamento não é estático, podendo ser revisado anualmente em períodos específicos (ciclo de
                    revisão). Nesse sentido, as informações identificadas abaixo poderão ser utilizadas na próxima
                    revisão do PPA e/ou na próxima elaboração ou gestão do PTA.
                  </b>
                </p>
              </label>
            </div>

            <RotuloSeplag nome="Selecione abaixo quais as possíveis melhorias no Programa:" cols="6">
              <div style={{ marginRight: "10px" }}>
                <Dropdown
                  value={selectedTipoMelhoria}
                  onChange={(e) => setSelectedTipoMelhoria(e.value)}
                  options={tipoMelhoria}
                  optionLabel="descTipoSugestaoMelhoria"
                  optionValue="idenTipoSugestaoMelhoria"
                  placeholder="Selecione um tipo disponível"
                  showClear
                  style={{ width: "100%" }}
                  disabled={!podeAcessarCampo()}
                />
              </div>
            </RotuloSeplag>

            <br />

            <RotuloSeplag
              nome="Dê sua sugestão para melhorar a formulação da ação na revisão do PPA no próximo ciclo."
              cols="12"
            >
              <div style={{ marginRight: "10px" }}>
                <InputTextarea
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                  rows={5}
                  maxLength={qtdMaxCaracteres}
                  onKeyUp={(e) => setCountCaracteres(qtdMaxCaracteres - e.target.value.length)}
                  cols="120"
                  style={{ width: "100%" }}
                  readOnly={verifyReadOnly()}

                  //disabled={!podeAcessarCampo()}  //Conforme tarefa: #23258
                />
              </div>
              <div className="field col-12 md:col-12 ">
                <span>
                  <b>{formatarMilhar(countCaracteres)}</b> caractere(s) restante(s)
                </span>
              </div>
            </RotuloSeplag>

            {exercicio2024 && (
              <>
                <div style={{ marginRight: "10px" }}>
                  <div className="p-fluid grid">
                    <div className="col-12 md:col-8 "></div>
                    <div className="col-12 md:col-2 "></div>
                    {campoHabilitado && (
                      <div className="col-12 md:col-2 ">
                        {!editarItem ? (
                          <Button
                            label="Adicionar"
                            className="p-button-primary"
                            onClick={adicionarItem}
                            disabled={!podeAcessarCampo()}
                          />
                        ) : (
                          <Button label="Salvar" className="p-button-primary" onClick={editarItemGrid} />
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <ConfirmDialog />

                <CardSeplag>
                  <DataTable
                    emptyMessage="Não foram encontradas sugestões de melhoria para esta ação"
                    value={sugestaoMelhoria}
                  >
                    <Column header="Item" field="descTipoSugestaoMelhoria" />
                    <Column header="Sugestão" body={renderSugestao} />
                    <Column header="Nome" field="nomeApresentacao" />
                    <Column
                      header="Ações"
                      body={acoesTemplate}
                      style={{ textAlign: "center", width: "12%", justifyContent: "center" }}
                      field="idenAndamento"
                    />
                  </DataTable>
                </CardSeplag>
              </>
            )}
          </>
        )}

        {!exercicio2024 && (
          <QuestionarioSeplag
            campos={campos}
            setCampos={salvarDadosAtualizados}
            condicao={props.condicao}
            IsMaximoCaracteres={true}
            qtdMaxCaracteres={4000}
            isDisabled={!location.state.PODE_ENVIAR_SUGESTAO_MELHORIA_PROGRAMA}
          ></QuestionarioSeplag>
        )}
        <br />
        <br />
      </CardSeplagScrol>
      <br />
      <div className="p-fluid grid">
        <div className="field col-12 md:col-8 ">&nbsp;</div>
        {exercicio2024 && <div className="field col-12 md:col-2 "></div>}
        <div className="field col-12 md:col-2 ">
          <Button label="Voltar" className="p-button-secondary" onClick={voltar} />
        </div>
        {!exercicio2024 && (
          <div className="field col-12 md:col-2 ">
            <Button
              label="Salvar"
              className="p-button-success"
              onClick={salvar}
              disabled={!location.state.PODE_ENVIAR_SUGESTAO_MELHORIA_PROGRAMA}
            />
          </div>
        )}
        {/*<div className="field col-12 md:col-2 ">
                        <Button label="Remover" className="p-button-danger"  onClick={remover} />
                    </div>*/}
      </div>
    </>
  );
};

export default AvaliacaoProgramaRagSugestao;
